/**
 * The one glyph vocabulary for extraction state, shared by the ledger row and
 * the app-shell indicator so a phase never looks different in two places.
 */
import {
  CircleCheckIcon,
  CircleDashedIcon,
  ClockIcon,
  Loader2Icon,
  TriangleAlertIcon,
  XCircleIcon,
} from 'lucide-react';

import type { ExtractionActivityTone } from '@/lib/extraction-runs/extraction-activity-summary';
import type { ExtractionRunPhase } from '@/lib/extraction-runs/extraction-run-store';

export interface ExtractionGlyph {
  readonly Icon: typeof ClockIcon;
  readonly className: string;
  readonly spin: boolean;
}

export const EXTRACTION_PHASE_GLYPHS: Record<ExtractionRunPhase, ExtractionGlyph> = {
  queued: { Icon: ClockIcon, className: 'text-muted-foreground', spin: false },
  running: { Icon: Loader2Icon, className: 'text-accent', spin: true },
  succeeded: { Icon: CircleCheckIcon, className: 'text-foreground', spin: false },
  partial: { Icon: TriangleAlertIcon, className: 'text-warning', spin: false },
  failed: { Icon: XCircleIcon, className: 'text-destructive', spin: false },
  cancelled: { Icon: CircleDashedIcon, className: 'text-muted-foreground', spin: false },
};

export const EXTRACTION_TONE_GLYPHS: Record<ExtractionActivityTone, ExtractionGlyph> = {
  attention: EXTRACTION_PHASE_GLYPHS.partial,
  active: EXTRACTION_PHASE_GLYPHS.running,
  ready: EXTRACTION_PHASE_GLYPHS.succeeded,
};
